import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { services } from '../../apis';

export const getUpcomingSessions = createAsyncThunk(
	'session/getUpcomingSessions',
	async (body: any) => {
		const data = await services.sessionService.fetchUpcomingSessions(
			body.userId,
			body.userType
		);
		console.log('session data onevone slice', data);
		// const temp = data.filter((el: any) => el.upcomingInterviews.length > 0);
		// console.log('session data', temp, data);

		return data;
	}
);
export const getMeetingLink = createAsyncThunk(
	'session/getMeetingLink',
	async (body: any) => {
		const data = await services.sessionService.fetchMeetingLink(
			body.roomId,
			body.userId,
			body.userType
		);
		return data;
	}
);
export const getSessionWithoutFeedback = createAsyncThunk(
	'session/getSessionWithoutFeedback',
	async (userId: string) => {
		const data = await services.sessionService.getSessionWithoutFeedback(
			userId
		);
		return data;
	}
);
export const postFeedback = createAsyncThunk(
	'session/postFeedback',
	async (body: any) => {
		const data = await services.sessionService.postFeedback(
			body.sessionId,
			body.userType,
			body.formData
		);
		return data;
	}
);

interface SessionState {
	sessions: any[];
	loading: boolean;
	error: {
		state: boolean;
		message: string;
	};
	sessionsWithoutFeedback: any[];
	modalLoading: boolean;
	modalOpen: boolean;
	feedbackGiven: boolean;
	meetingLink: string;
	userType: string;
	showFeedbackModal: boolean;
	feedbacks: any[];
	videos: any[];
	score: any[];
}

const initialState: SessionState = {
	sessions: [],
	showFeedbackModal: false,
	loading: false,
	error: {
		state: false,
		message: '',
	},
	meetingLink: '',
	modalLoading: false,
	//feedback session
	sessionsWithoutFeedback: [],
	modalOpen: false,
	feedbackGiven: false,
	userType: '',
	feedbacks: [],
	videos: [],
	score: [],
};

export const sessionSlice: any = createSlice({
	name: 'sessions',
	initialState,
	reducers: {
		setModalClose: (state) => {
			state.modalOpen = false;
		},
		closeFeedbackModal: (state) => {
			state.showFeedbackModal = false;
		},
		openFeedbackModal: (state) => {
			state.showFeedbackModal = true;
		},
		setUserTypeMentor: (state) => {
			state.userType = 'MENTOR';
		},
		setUserTypeStudent: (state) => {
			state.userType = 'STUDENT';
		},
	},
	extraReducers: {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getUpcomingSessions.pending]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.loading = true;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getUpcomingSessions.fulfilled]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.sessions = action.payload.sessionData;
			state.feedbacks = action.payload.feedbackData;
			state.error.state = false;
			state.error.message = '';
			state.videos = action.payload.videoData;
			state.score = action.payload.scoreData;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getUpcomingSessions.rejected]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getSessionWithoutFeedback.pending]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.loading = true;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getSessionWithoutFeedback.fulfilled]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.sessionsWithoutFeedback = action.payload;
			state.modalOpen =
				state.sessionsWithoutFeedback.length > 0 ? true : false;
			state.error.state = false;
			state.error.message = '';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getSessionWithoutFeedback.rejected]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.loading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[postFeedback.pending]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.modalLoading = true;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[postFeedback.fulfilled]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.feedbackGiven = true;
			state.modalLoading = false;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[postFeedback.rejected]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.modalLoading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getMeetingLink.pending]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.loading = true;
		},
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		[getMeetingLink.fulfilled]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.meetingLink = action.payload;
			state.loading = false;
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		}, //@ts-ignore
		[getMeetingLink.rejected]: (
			state: SessionState,
			action: PayloadAction<any>
		) => {
			state.modalLoading = false;
			state.error.state = true;
			state.error.message = 'Error, please try again later';
		},
	},
});

//Exporting Actions
export const {
	setModalClose,
	setUserTypeMentor,
	setUserTypeStudent,
	closeFeedbackModal,
	openFeedbackModal,
} = sessionSlice.actions;
export default sessionSlice.reducer;
